import { z } from 'zod';

/**
 * Zod schema for validating feedback form values
 */
export const feedbackFormSchema = z.object({
  rating: z
    .number()
    .int('Rating must be a whole number')
    .min(1, 'Please select a rating')
    .max(5, 'Rating must be between 1 and 5'),
  message: z
    .string()
    .trim()
    .min(10, 'Message must be at least 10 characters')
    .max(2000, 'Message must be less than 2000 characters'),
  isBug: z.boolean(),
});

export type FeedbackFormValues = z.infer<typeof feedbackFormSchema>;
